const initialState = {
    actions: false,
    approvals: false
}

const routeTrackingReducer = (state = initialState, action) => {
    switch (action.type) {
        case "UPDATE_ACTIONS":
            return {
                ...state,
                actions: action.state,
            }
        case "UPDATE_APPROVALS":
            return {
                ...state,
                approvals: action.state,
            }
        default: {
            return state;
        }
    }
}
export default routeTrackingReducer;